import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import MysteryRevealCard from 'Components/Order/KeyReveals/MysteryRevealCard';
import useViewport from 'Hooks/useViewport';

import 'Components/Order/KeyReveals/RevealPrizeStep.scss';

export default function RevealPrizeStep({ testReveal, prizeName, viewKeys, type, showCard, game }) {
  const { isAboveMd, isBelowLg } = useViewport();
  return (
    <div className="RevealPrizeStep">
      {!testReveal &&
        <React.Fragment>
          <div className="RevealPrizeStep__title">
            <FormattedMessage id="reveal-prize-step.title" defaultMessage="Congratulations! You've won" />
          </div>
          {(!showCard || isBelowLg) &&
            <div className="RevealPrizeStep__item">
              {prizeName}
            </div>
          }
          {showCard && isAboveMd &&
            <div className="RevealPrizeStep__itemCard">
              <MysteryRevealCard
                game={game}
                soundOn={false}
              />
            </div>
          }
          <button className="MysteryReveal__revealButton mt-3" onClick={() => { viewKeys(); }}>
            <FormattedMessage id="reveal-prize-step.view" defaultMessage="View your key" />
          </button>
        </React.Fragment>
      }
      {testReveal &&
        <React.Fragment>
          <div className="RevealPrizeStep__title">
            {type === 'scratchcard' &&
              <FormattedMessage
                id="reveal-prize-step.title.test.scratchcard"
                defaultMessage="Now you’ve tried it, get your scratch card and see what you find!"
              />
            }
            {(type === 'wheel' || type === 'wheel alt') &&
              <FormattedMessage
                id="reveal-prize-step.title.test.wheel"
                defaultMessage="Now you’ve tried it, get your wheel and see what you find!"
              />
            }
          </div>
        </React.Fragment>
      }
    </div>
  );
}

RevealPrizeStep.propTypes = {
  game: PropTypes.shape({}),
  prizeName: PropTypes.string,
  showCard: PropTypes.bool,
  testReveal: PropTypes.bool,
  type: PropTypes.string,
  viewKeys: PropTypes.func,
};

RevealPrizeStep.defaultProps = {
  game: {},
  prizeName: '',
  showCard: false,
  testReveal: false,
  type: '',
  viewKeys: () => {},
};
